import { VehicleOrigin, vehicleOriginMessages } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import type { Option } from "src/components/form/select/Select"
import { useConfig } from "src/hooks"
import type { InventoryInformationFormValues } from "../InventoryInformationFormValues"

export const useVehicleOriginOptions = (
	value: Partial<InventoryInformationFormValues>,
	isPVMSVehicle: boolean,
): Option[] => {
	const { formatMessage } = useIntl()
	const { intakeTypeWerkswagenAvailable } = useConfig()

	if (value.vehicleType === "COMMISSION_CAR") {
		return [
			{
				label: formatMessage(vehicleOriginMessages.COMMISSION_CAR),
				value: VehicleOrigin.COMMISSION_CAR,
			},
		]
	}

	if (isPVMSVehicle) {
		return [
			{
				label: formatMessage(vehicleOriginMessages.FACTORY_ORDER),
				value: VehicleOrigin.FACTORY_ORDER,
			},
		]
	}

	return [
		{
			label: formatMessage(vehicleOriginMessages.PURCHASE_FROM_PRIVATE_OWNER),
			value: VehicleOrigin.PURCHASE_FROM_PRIVATE_OWNER,
		},
		{
			label: formatMessage(vehicleOriginMessages.PURCHASE_FROM_COMMERCIAL_OWNER),
			value: VehicleOrigin.PURCHASE_FROM_COMMERCIAL_OWNER,
		},
		{
			label: formatMessage(vehicleOriginMessages.PURCHASE_FROM_OTHER_PORSCHE_CENTER),
			value: VehicleOrigin.PURCHASE_FROM_OTHER_PORSCHE_CENTER,
		},
		{
			label: formatMessage(vehicleOriginMessages.PURCHASE_FROM_IMPORTER),
			value: VehicleOrigin.PURCHASE_FROM_IMPORTER,
		},
		...(intakeTypeWerkswagenAvailable
			? [
					{
						label: formatMessage(vehicleOriginMessages.PURCHASE_FROM_WERKSWAGEN),
						value: VehicleOrigin.PURCHASE_FROM_WERKSWAGEN,
					},
				]
			: []),
		{
			label: formatMessage(vehicleOriginMessages.TRADE_IN_FOR_NEW_CAR),
			value: VehicleOrigin.TRADE_IN_FOR_NEW_CAR,
		},
		{
			label: formatMessage(vehicleOriginMessages.TRADE_IN_FOR_USED_CAR),
			value: VehicleOrigin.TRADE_IN_FOR_USED_CAR,
		},
		{
			label: formatMessage(vehicleOriginMessages.FACTORY_ORDER),
			value: VehicleOrigin.FACTORY_ORDER,
		},
		...(value.vehicleType !== "NEW_CAR"
			? [
					{
						label: formatMessage(vehicleOriginMessages.LEASE_RETURN),
						value: VehicleOrigin.LEASE_RETURN,
					},
				]
			: []),
	]
}
